import type { ErrorResponse } from '@sancare-commons/misc/api'

export type Method = 'GET' | 'POST' | 'DELETE' | 'PUT' | 'PATCH'

export class ApiRequest {
  name: string
  fetching = false
  error: ErrorResponse = null
  ok = false
  method: Method
  url: string
  doNotRetry = false
  cannotBeDelayed = false

  constructor(name: string, method: Method, url: string, doNotRetry = false, cannotBeDelayed = false) {
    this.name = name
    this.method = method
    this.url = url
    this.doNotRetry = doNotRetry
    this.cannotBeDelayed = cannotBeDelayed
  }

  public clone(): ApiRequest {
    return new ApiRequest(this.name, this.method, this.url, this.doNotRetry, this.cannotBeDelayed)
  }

  public start() {
    this.fetching = true
    this.error = null
    this.ok = false
  }

  public end(error?: ErrorResponse) {
    this.fetching = false
    this.error = error || null
    this.ok = !error
  }

  public reset() {
    this.fetching = false
    this.error = null
    this.ok = false
  }

  public getUrl(urlParams?: { [key: string]: string | number }): string {
    if (!urlParams) {
      return this.url
    }
    const localUrlParams = { ...urlParams }

    let url = this.url
    const regex = /{(.+?)}/g
    const matches = [...this.url.matchAll(regex)]
    for (const match of matches) {
      if (typeof localUrlParams[match[1]] !== 'undefined') {
        url = url.replace(`{${match[1]}}`, String(urlParams[match[1]]))
        delete localUrlParams[match[1]]
      }
    }

    if (Object.keys(localUrlParams).length) {
      // as any is used because URLSearchParams does not accept number as it should: https://github.com/microsoft/TypeScript/issues/32951
      const sp = new URLSearchParams(localUrlParams as any) // eslint-disable-line @typescript-eslint/no-explicit-any
      return `${url}?${sp.toString()}`
    }

    return url
  }

  public setUrl(url: string) {
    this.url = url
  }
}
